import { render } from "./LetsTalkBlock.vue?vue&type=template&id=203c6154&scoped=true"
import script from "./LetsTalkBlock.vue?vue&type=script&lang=js"
export * from "./LetsTalkBlock.vue?vue&type=script&lang=js"

import "./LetsTalkBlock.vue?vue&type=style&index=0&id=203c6154&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203c6154"]])

export default __exports__